import { useEffect, useMemo, useState } from 'react';
import OnelivePageLayout from './OnelivePageLayout';
import OneliveSubPageLayout from './OneliveSubPageLayout';
import { NoticePostDetail, fetchNoticePost, navigate, resolveNoticePostIdFromLocation } from './api';

interface NoticeBoardDetailPageProps {
  postId?: string | number;
}

export default function NoticeBoardDetailPage({ postId }: NoticeBoardDetailPageProps) {
  const [post, setPost] = useState<NoticePostDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const id = useMemo(() => resolveNoticePostIdFromLocation(postId), [postId]);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }
    let mounted = true;
    (async () => {
      setLoading(true);
      const detail = await fetchNoticePost(id);
      if (mounted) {
        setPost(detail);
        setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [id]);

  return (
    <OnelivePageLayout pageClassName="onelive-notice-page">
      <OneliveSubPageLayout title="공지사항">
        <div className="onelive-notice-view-wrap">
          {loading ? (
            <p className="onelive-sub-loading">로딩 중...</p>
          ) : !post ? (
            <p className="onelive-sub-empty">공지사항을 찾을 수 없습니다.</p>
          ) : (
            <>
              <div className="onelive-notice-view-head-simple">
                <h3>{post.title}</h3>
                {post.created_at_formatted ? (
                  <span className="onelive-notice-view-date">{post.created_at_formatted}</span>
                ) : null}
              </div>
              <div
                className="onelive-notice-view-body-simple"
                dangerouslySetInnerHTML={{ __html: post.content ?? '' }}
              />
              <div className="onelive-notice-view-actions">
                <button type="button" onClick={() => navigate('/board/notice')}>
                  목록
                </button>
              </div>
            </>
          )}
        </div>
      </OneliveSubPageLayout>
    </OnelivePageLayout>
  );
}
